<template>
  <div v-loading.fullscreen.lock="loading" class="mall_homepage">
    <!-- 头部 -->
    <header-bar :rightPart="true"  @backTo="backTo">
      <template slot="difinePort">
          <div class="top_right" @click="toRecord">
            <img src="@/images/record.png" />
            <span>兑换记录</span>
          </div>
      </template>
    </header-bar>
    <van-tabs v-model="active" style="margin-top:45px;" @click="toggleTabs">
      <van-tab title="自选节日慰问" name="welfare">
          <div>
            <!-- 节日慰问商品列表 -->
            <div class="goods_list" v-if="shoppList&&shoppList.length">
              <div v-for="(item,index) in shoppList" :key="index" @click="toDetail(item)">
                <img :src="item.mainImageSrc" />
                <span>{{item.productName}}</span>
              </div>
            </div>
            <!-- 商品列表 结束 -->
            <!-- 没数据时 -->
            <div class="blank" v-else>
              <img src="@/images/404-02.png" alt>
            </div>
          </div>
      </van-tab>
       <van-tab title="自选生日慰问" name="birthday">
         <div>
            <!-- 生日慰问商品列表 -->
            <div class="goods_list" v-if="shoppList&&shoppList.length">
              <div v-for="(item,index) in shoppList" :key="index" @click="toDetail(item)">
                <img :src="item.mainImageSrc" />
                <span>{{item.productName}}</span>
              </div>
            </div>
            <!-- 商品列表 结束 -->
            <!-- 没数据时 -->
            <div class="blank" v-else>
              <img src="@/images/404-02.png" alt>
            </div>
         </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import { toast } from "@/common/api/api.js";
import headerBar from "../../components/headerBar";
export default {
  components: {
    headerBar
  },
  data() {
    return {
      loading:true,
      shoppList:[],
      active:'welfare',
      toggleVal:''
    };
  },
  mounted(){
    if(this.$route.query.welfareCategory){
       this.active=this.$route.query.welfareCategory==0?'welfare':'birthday'  //自动切换tab栏
    }else{
      this.active='welfare'
    }
    this.toggleVal=this.active=='welfare'?'welfare':'birthday'
    this.queryData(this.toggleVal);
  },
  methods:{
    // 切换tab栏
    toggleTabs(val){
      this.toggleVal = val
      this.queryData(this.toggleVal) //获取接口
    },
    // 返回公众号首页
    backTo(){
      this.$router.push({
        path:"/homeZhyf"
      });
    },
    // 获取商城首页数据（节日慰问）
    queryData(types){ 
      console.log('tabsType',types)
      const {welfareId} = this.$route.query;
      let categoryType = types=='welfare'?'0':'1'
      let params = {
        welfareCategory:categoryType
        // testCode:'bjttyytest',
        // welfareId:'65de00e7754a4a9f9ba0c1b7a4a286d7'
      }
      if(welfareId)params.welfareId=welfareId;
      this.centralControl.axios.centralControl(
        "eShopProductList",
        res => {
          this.loading=false;
          if (res.code == 200) {
            this.shoppList=res.data;
          } else {
            toast(this, res.message,"error");
          }
        },
        params
      );
    },
    // 跳转-兑换记录
    toRecord(){
      let welfareCategory = this.toggleVal=='welfare'?'0':'1' //传一个标识过去，区分节日慰问和生日慰问
      this.$nextTick(()=>{
        this.$router.push({
          path: 'recordList',
          query:{
            welfareCategory: welfareCategory
          }
        })
      })
    },
    // 跳转-商品详情
    toDetail(item){
      let category = this.toggleVal=='welfare'?'0':'1'
      if(!item.id||!item.welfareInfo.id)return;
      this.$router.push({
        path:'goodsDetail',
        query:{
          id:item.id,
          welfareId:item.welfareInfo.id,
          welfareCategory:category
        }
      })
    }
  }
}
</script>
<style lang="stylus" type="stylesheet/stylus">
@import "../../assets/stylus/common"
  .mall_homepage{
   .ctn_top{
      margin-top:6px !important;
    }
    .van-tabs__line {
      width: 86px !important;
    }
    .van-tabs__nav--line{
      background-color #F0F0F4 !important;
      position: fixed;
      width:100%;
      height:28px;
      padding-top:8px;
    }
     >>> .van-tab--active {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #353535;
    }

     >>> .van-tab {
      color: #353535;
    }

     >>> .van-tab__text {
      font-weight: 500;
    }

     >>> .van-tab--active .van-tab__text {
      font-weight: 600;
    }

    .top-box {
      justify-content: space-between;
      .top_right {
        margin-right: 16px;
        font-size:14px;
        font-family:PingFang-SC-Medium,PingFang-SC;
        font-weight:500;
        color:rgba(41,190,188,1);
        img {
          width: 20px;
          margin-right: 4px;
        }
      }
    }
    .goods_list {
      background: #F4F5F9;
      display: flex;
      flex-wrap:wrap;
      padding-bottom: 10px;
      >div {
        // text-align: center;
        border-radius: 10px;
        width: 46.25%;
        margin-left:2.5%;
        margin-top:2.5%;
        background: #FFF;
        img {
          width: 100%;
          border-radius: 10px 10px 0 0;
          height: 130px;
        }
        span {
          display:inline-block;
          padding: 0 20px;
          width: 80%;
          ellipsis();
          font-size:16px;
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight:600;
          color:rgba(53,53,53,1);
          line-height:50px;
        }
      }
    }
  }
</style>